import '@PROJECT_ROOT/assets/desktop/js/jquery/plugins/jquery.jcarousel.min.0.2.9';
import '@PROJECT_ROOT/assets/desktop/js/guide/guideGallery';
import guideInlineGallery from '@PROJECT_ROOT/assets/desktop/js/guide/guideInlineGallery';
import initBlogGAEvents from '@PROJECT_ROOT/assets/shared/js/blog/googleAnalytics';
import { ebookForm } from '@PROJECT_ROOT/assets/desktop/js/ebook/ebookForm';

$(() => {
    guideInlineGallery();
    initBlogGAEvents();
    ebookForm()();
});
